import React from "react";
import { useSpecialFunctions } from "../../functions";

const ManuallyScoreTicketsTable = ({
  manuallyScoreTickets,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
}) => {
  const { getTimeInfo } = useSpecialFunctions();
  // Headers
  let headers,
    tableInfoTickets = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDTicket</th>
      <th>Ticket #</th>
      <th>Account</th>
      <th>Placed</th>
      <th>Status</th>
      <th>Description</th>
      <th>Stake</th>
      <th>Paid</th>
    </tr>
  );

  // Tickets OnChange
  const ticketsChangeHandler = (ticketID) => {
    if (selectedTicketsVoidScore.includes(ticketID)) {
      // Si el id ya está en la lista, lo elimina
      setSelectedTicketsVoidScore(
        selectedTicketsVoidScore.filter((item) => item !== ticketID)
      );
    } else {
      // Si el id no está en la lista, lo agrega
      setSelectedTicketsVoidScore([...selectedTicketsVoidScore, ticketID]);
    }
  };

  // The main Tickets table
  if (manuallyScoreTickets.length !== 0) {
    let ticketStatus;
    tableInfoTickets = manuallyScoreTickets.map((item, i) => {
      ticketStatus = "";

      switch (item.TicketStatus) {
        case 0:
          ticketStatus = "Open";
          break;
        case 2:
          ticketStatus = "Scored";
          break;
        default:
          break;
      }

      return (
        <React.Fragment key={i}>
          <tr
            key={item.TicketID}
            onClick={() => ticketsChangeHandler(item.TicketID)}
            className={
              selectedTicketsVoidScore.includes(item.TicketID)
                ? "shadedRow"
                : ""
            }
          >
            <td key={"TicketID" + i} className="d-none">
              {item.TicketID}
            </td>
            {/* Ticket# */}
            <td
              key={"TicketNum" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TicketID}
            </td>
            {/* Account */}
            <td
              key={"Account" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.AccountUserName}
            </td>
            {/* Placed */}
            <td
              key={"Placed" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {getTimeInfo(item.PlacedDateTime)}
            </td>
            {/* Status */}
            <td
              key={"Status" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {ticketStatus}
            </td>

            {/* TicketDesc */}
            <td
              key={"TicketDesc" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TicketDesc}
            </td>
            {/* TotalStake */}
            <td
              key={"TotalStake" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TotalStake}
            </td>
            {/* WinPaid */}
            <td
              key={"WinPaid" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.WinPaid}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  return (
    <div
      style={{
        overflow: "auto",
      }}
      className="tablesPastPost"
    >
      <table className="table table-hover table-sm mt-2">
        <thead style={{ position: "sticky", top: "0", background: "#d9d9d9" }}>
          {headers}
        </thead>
        <tbody className="table-lg">{tableInfoTickets}</tbody>
      </table>
    </div>
  );
};

export default ManuallyScoreTicketsTable;
